// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
/**
 * Centrale plaatsenlijst voor WilsApp — alle Nederlandse woonplaatsen.
 *
 * Bron: open 4PP-dataset (woonplaatsen, CC-BY). Eenmalig gedistilleerd tot unieke,
 * Nederlands gesorteerde plaatsnamen; geen runtime-API of externe databron.
 * Hergebruikt overal waar een plaats wordt gekozen (notaris, uitvaartverzorger, ...).
 *
 * Vrije invoer blijft mogelijk via het plaatsveld (PlaceField): een plaats die hier
 * niet in staat kan altijd worden ingetypt, zodat bestaande/onbekende waarden behouden blijven.
 */
export const NL_PLACES: string[] = [
  'Aadorp',
  'Aagtekerke',
  'Aalden',
  'Aalsmeer',
  'Aalsmeerderbrug',
  'Aalst',
  'Aalsum',
  'Aalten',
  'Aardenburg',
  'Aarlanderveen',
  'Aarle-Rixtel',
  'Aartswoud',
  'Abbega',
  'Abbekerk',
  'Abbenbroek',
  'Abbenes',
  'Abcoude',
  'Achlum',
  'Achterveld',
  'Achthuizen',
  'Achtmaal',
  'Acquoy',
  'Adorp',
  'Aduard',
  'Aerdenhout',
  'Aerdt',
  'Afferden',
  'Agelo',
  'Akersloot',
  'Akkrum',
  'Akmarijp',
  'Albergen',
  'Alblasserdam',
  'Alde Leie',
  'Aldeboarn',
  'Aldtsjerk',
  'Alem',
  'Alkmaar',
  'Allingawier',
  'Almelo',
  'Almen',
  'Almere',
  'Almkerk',
  'Alphen',
  'Alphen aan den Rijn',
  'Alteveer',
  'Altforst',
  'Ambt Delden',
  'Ameide',
  'Amen',
  'America',
  'Amerongen',
  'Amersfoort',
  'Ammerstol',
  'Ammerzoden',
  'Amstelhoek',
  'Amstelveen',
  'Amstenrade',
  'Amsterdam',
  'Amsterdam-Zuidoost',
  'Andel',
  'Andelst',
  'Anderen',
  'Andijk',
  'Ane',
  'Anerveen',
  'Anevelde',
  'Angeren',
  'Angerlo',
  'Anjum',
  'Ankeveen',
  'Anloo',
  'Anna Paulowna',
  'Annen',
  'Annerveenschekanaal',
  'Ansen',
  'Apeldoorn',
  'Appelscha',
  'Appeltern',
  'Appingedam',
  'Arcen',
  'Arkel',
  'Arnemuiden',
  'Arnhem',
  'Arriën',
  'Arum',
  'Asch',
  'Asperen',
  'Assen',
  'Assendelft',
  'Asten',
  'Augsbuurt',
  'Augustinusga',
  'Austerlitz',
  'Avenhorn',
  'Axel',
  'Azewijn',
  'Baaiduinen',
  'Baaium',
  'Baak',
  'Baambrugge',
  'Baard',
  'Baarland',
  'Baarle-Nassau',
  'Baarlo',
  'Baarn',
  'Baars',
  'Babberich',
  'Babyloniënbroek',
  'Bad Nieuweschans',
  'Badhoevedorp',
  'Baexem',
  'Baflo',
  'Bakel',
  'Bakhuizen',
  'Bakkeveen',
  'Balgoij',
  'Balinge',
  'Balk',
  'Balkbrug',
  'Balloërveld',
  'Balloo',
  'Ballum',
  'Baneheide',
  'Banholt',
  'Bant',
  'Bantega',
  'Barchem',
  'Barendrecht',
  'Barger-Compascuum',
  'Barneveld',
  'Barsingerhorn',
  'Basse',
  'Batenburg',
  'Bathmen',
  'Bavel',
  'Bears',
  'Bedum',
  'Beegden',
  'Beek',
  'Beek en Donk',
  'Beek-Ubbergen',
  'Beekbergen',
  'Beemte Broekland',
  'Beers',
  'Beerta',
  'Beerze',
  'Beerzerveld',
  'Beesd',
  'Beesel',
  'Beets',
  'Beetsterzwaag',
  'Beilen',
  'Beinsdorp',
  'Belfeld',
  'Bellingwolde',
  'Belt-Schutsloot',
  'Beltrum',
  'Bemelen',
  'Bemmel',
  'Beneden-Leeuwen',
  'Bennebroek',
  'Bennekom',
  'Benneveld',
  'Benningbroek',
  'Benschop',
  'Bentelo',
  'Benthuizen',
  'Bentveld',
  'Berg en Dal',
  'Berg en Terblijt',
  'Bergambacht',
  'Bergeijk',
  'Bergen',
  'Bergen aan Zee',
  'Bergen op Zoom',
  'Bergentheim',
  'Bergharen',
  'Berghem',
  'Bergschenhoek',
  'Beringe',
  'Berkel en Rodenrijs',
  'Berkel-Enschot',
  'Berkenwoude',
  'Berkhout',
  'Berlicum',
  'Berltsum',
  'Bern',
  'Best',
  'Beugen',
  'Beuningen',
  'Beusichem',
  'Beutenaken',
  'Beverwijk',
  'Biddinghuizen',
  'Bierum',
  'Biervliet',
  'Biest-Houtakker',
  'Biezenmortel',
  'Biggekerke',
  'Bilthoven',
  'Bingelrade',
  'Bitgum',
  'Bitgummole',
  'Bladel',
  'Blankenham',
  'Blaricum',
  'Blauwestad',
  'Blauwhuis',
  'Bleiswijk',
  'Blesdijke',
  'Bleskensgraaf',
  'Blessum',
  'Blije',
  'Blijham',
  'Blitterswijck',
  'Bloemendaal',
  'Blokker',
  'Blokzijl',
  'Boazum',
  'Bocholtz',
  'Bodegraven',
  'Boekel',
  'Boelenslaan',
  'Boer',
  'Boerakker',
  'Boesingheliede',
  'Boijl',
  'Boksum',
  'Bolsward',
  'Bontebok',
  'Boornbergum',
  'Boornzwaag',
  'Borculo',
  'Borger',
  'Borgercompagnie',
  'Borgsweer',
  'Born',
  'Borne',
  'Bornerbroek',
  'Bornwird',
  'Borssele',
  'Bosch en Duin',
  'Boschoord',
  'Boskoop',
  'Bosschenhoofd',
  'Botlek',
  'Bourtange',
  'Boven-Leeuwen',
  'Bovenkarspel',
  'Bovensmilde',
  'Boxmeer',
  'Boxtel',
  'Braamt',
  'Brakel',
  'Brandwijk',
  'Brantgum',
  'Breda',
  'Bredevoort',
  'Breedenbroek',
  'Breezand',
  'Breezanddijk',
  'Breskens',
  'Breugel',
  'Breukelen',
  'Breukeleveen',
  'Brielle',
  'Briltil',
  'Britsum',
  'Britswert',
  'Broek',
  'Broek in Waterland',
  'Broek op Langedijk',
  'Broekhuizen',
  'Broekhuizenvorst',
  'Broekland',
  'Broeksterwâld',
  'Bronkhorst',
  'Bronneger',
  'Bronnegerveen',
  'Brouwershaven',
  'Bruchem',
  'Brucht',
  'Bruchterveld',
  'Bruinehaar',
  'Bruinisse',
  'Brummen',
  'Brunssum',
  'Bruntinge',
  'Buchten',
  'Budel',
  'Budel-Dorplein',
  'Budel-Schoot',
  'Buggenum',
  'Buinen',
  'Buinerveen',
  'Buitenkaag',
  'Buitenpost',
  'Bunde',
  'Bunne',
  'Bunnik',
  'Bunschoten-Spakenburg',
  'Burdaard',
  'Buren',
  'Burgerbrug',
  'Burgerveen',
  'Burgh-Haamstede',
  'Burgum',
  'Burgwerd',
  'Burum',
  'Bussum',
  'Buurmalsen',
  'Cadier en Keer',
  'Cadzand',
  'Callantsoog',
  'Capelle aan den IJssel',
  'Castelré',
  'Castenray',
  'Casteren',
  'Castricum',
  'Chaam',
  'Clinge',
  'Coevorden',
  'Colijnsplaat',
  'Collendoorn',
  'Colmschate',
  'Cornwerd',
  'Cothen',
  'Creil',
  'Cromvoirt',
  'Cruquius',
  'Cuijk',
  'Culemborg',
  'Daarle',
  'Daarlerveen',
  'Dalem',
  'Dalen',
  'Dalerpeel',
  'Dalerveen',
  'Dalfsen',
  'Dalmsholte',
  'Damwâld',
  'Darp',
  'De Bilt',
  'De Blesse',
  'De Bult',
  'De Cocksdorp',
  'De Falom',
  'De Glind',
  'De Goorn',
  'De Groeve',
  'De Heen',
  'De Heurne',
  'De Hoef',
  'De Hoeve',
  'De Kiel',
  'De Klomp',
  'De Knipe',
  'De Koog',
  'De Krim',
  'De Kwakel',
  'De Lier',
  'De Lutte',
  'De Meern',
  'De Moer',
  'De Pol',
  'De Punt',
  'De Rijp',
  'De Schiphorst',
  'De Steeg',
  'De Tike',
  'De Veenhoop',
  'De Waal',
  'De Weere',
  'De Westereen',
  'De Wijk',
  'De Wilgen',
  'De Wilp',
  'De Woude',
  'De Zilk',
  'Dearsum',
  'Dedemsvaart',
  'Dedgum',
  'Deelen',
  'Deest',
  'Deil',
  'Deinum',
  'Delden',
  'Delfgauw',
  'Delfstrahuizen',
  'Delft',
  'Delfzijl',
  'Delwijnen',
  'Den Andel',
  'Den Bommel',
  'Den Burg',
  'Den Dolder',
  'Den Dungen',
  'Den Haag',
  'Den Ham',
  'Den Helder',
  'Den Hoorn',
  'Den Horn',
  'Den Hout',
  'Den Ilp',
  'Den Oever',
  'Den Velde',
  'Denekamp',
  'Deurne',
  'Deurningen',
  'Deurze',
  'Deventer',
  'Didam',
  'Diemen',
  'Diepenheim',
  'Diepenveen',
  'Dieren',
  'Diessen',
  'Diever',
  'Dieverbrug',
  'Diffelen',
  'Dijken',
  'Dinteloord',
  'Dinxperlo',
  'Diphoorn',
  'Dirkshorn',
  'Dirksland',
  'Dodewaard',
  'Doenrade',
  'Doesburg',
  'Doetinchem',
  'Doezum',
  'Dokkum',
  'Doldersum',
  'Domburg',
  'Donderen',
  'Dongen',
  'Dongjum',
  'Doniaga',
  'Donkerbroek',
  'Doorn',
  'Doornenburg',
  'Doornspijk',
  'Doorwerth',
  'Dordrecht',
  'Dorst',
  'Drachten',
  'Drachtstercompagnie',
  'Dreischor',
  'Drempt',
  'Dreumel',
  'Driebergen-Rijsenburg',
  'Drieborg',
  'Driebruggen',
  'Driehuis',
  'Driehuizen',
  'Driel',
  'Driewegen',
  'Driezum',
  'Drijber',
  'Drimmelen',
  'Drogeham',
  'Drogteropslagen',
  'Drongelen',
  'Dronryp',
  'Dronten',
  'Drouwen',
  'Drouwenermond',
  'Drouwenerveen',
  'Drunen',
  'Druten',
  'Duiven',
  'Duivendrecht',
  'Duizel',
  'Dussen',
  'Dwingeloo',
  'Eagum',
  'Earnewâld',
  'Easterein',
  'Easterlittens',
  'Eastermar',
  'Easterwierrum',
  'Echt',
  'Echteld',
  'Echten',
  'Echtenerbrug',
  'Eck en Wiel',
  'Eckelrade',
  'Edam',
  'Ede',
  'Ederveen',
  'Ee',
  'Eede',
  'Eefde',
  'Eelde',
  'Eelderwolde',
  'Eemdijk',
  'Eemnes',
  'Eemshaven',
  'Een',
  'Een West',
  'Eenrum',
  'Eenum',
  'Eerbeek',
  'Eersel',
  'Eerste Exloërmond',
  'Ees',
  'Eesergroen',
  'Eeserveen',
  'Eesterga',
  'Eesveen',
  'Eethen',
  'Eext',
  'Eexterveen',
  'Eexterveensche kanaal',
  'Eexterzandvoort',
  'Egchel',
  'Egmond aan Den Hoef',
  'Egmond aan Zee',
  'Egmond-Binnen',
  'Eibergen',
  'Eijsden',
  'Eindhoven',
  'Einighausen',
  'Ekehaar',
  'Elahuizen',
  'Elburg',
  'Eldersloo',
  'Eleveld',
  'Elim',
  'Elkenrade',
  'Ell',
  'Ellecom',
  'Ellemeet',
  'Ellertshaar',
  'Ellewoutsdijk',
  'Elp',
  'Elsendorp',
  'Elshout',
  'Elsloo',
  'Elspeet',
  'Elst',
  'Emmeloord',
  'Emmen',
  'Emmer-Compascuum',
  'Empe',
  'Emst',
  'Engwierum',
  'Enkhuizen',
  'Ens',
  'Enschede',
  'Enspijk',
  'Enter',
  'Enumatil',
  'Epe',
  'Epen',
  'Eppenhuizen',
  'Epse',
  'Erica',
  'Erichem',
  'Erlecom',
  'Erm',
  'Ermelo',
  'Erp',
  'Esbeek',
  'Esch',
  'Escharen',
  'Espel',
  'Est',
  'Etten',
  'Etten-Leur',
  'Europoort',
  'Eursinge',
  'Everdingen',
  'Evertsoord',
  'Ewijk',
  'Exloërveen',
  'Exloo',
  'Exmorra',
  'Eygelshoven',
  'Eys',
  'Ezinge',
  'Farmsum',
  'Feanwâlden',
  'Feerwerd',
  'Feinsum',
  'Ferwert',
  'Ferwoude',
  'Fijnaart',
  'Finsterwolde',
  'Firdgum',
  'Fleringen',
  'Fluitenberg',
  'Fochteloo',
  'Follega',
  'Folsgare',
  'Formerum',
  'Foudgum',
  'Foxhol',
  'Foxwolde',
  'Franeker',
  'Frederiksoord',
  'Friens',
  'Frieschepalen',
  'Froombosch',
  'Gaanderen',
  'Gaast',
  'Gaastmeer',
  'Galder',
  'Gameren',
  'Gapinge',
  'Garderen',
  'Garmerwolde',
  'Garminge',
  'Garnwerd',
  'Garrelsweer',
  'Garsthuizen',
  'Garyp',
  'Gassel',
  'Gasselte',
  'Gasselternijveen',
  'Gasselternijveenschemond',
  'Gastel',
  'Gasteren',
  'Gauw',
  'Geelbroek',
  'Geerdijk',
  'Geersdijk',
  'Geertruidenberg',
  'Geervliet',
  'Gees',
  'Geesbrug',
  'Geesteren',
  'Geeuwenbrug',
  'Geffen',
  'Geldermalsen',
  'Gelderswoude',
  'Geldrop',
  'Geleen',
  'Gellicum',
  'Gelselaar',
  'Gemert',
  'Gemonde',
  'Genderen',
  'Gendringen',
  'Gendt',
  'Genemuiden',
  'Gennep',
  'Gerkesklooster',
  'Gersloot',
  'Geulle',
  'Geysteren',
  'Giesbeek',
  'Giessen',
  'Giessenburg',
  'Gieten',
  'Gieterveen',
  'Giethmen',
  'Giethoorn',
  'Gilze',
  'Ginnum',
  'Glane',
  'Glas',
  'Glimmen',
  'Godlinze',
  'Goedereede',
  'Goënga',
  'Goëngahuizen',
  'Goes',
  'Goingarijp',
  'Goirle',
  'Goor',
  'Gorinchem',
  'Gorredijk',
  'Gorssel',
  'Gouda',
  'Gouderak',
  'Goudriaan',
  'Goudswaard',
  'Goutum',
  'Graauw',
  'Grafhorst',
  'Graft',
  'Gramsbergen',
  'Grashoek',
  'Grathem',
  'Grave',
  'Greonterp',
  'Grevenbicht',
  'Griendtsveen',
  'Grijpskerk',
  'Grijpskerke',
  'Groede',
  'Groenekan',
  'Groeningen',
  'Groenlo',
  'Groesbeek',
  'Groessen',
  'Groet',
  'Grolloo',
  'Groningen',
  'Gronsveld',
  'Groot-Ammers',
  'Grootebroek',
  'Grootegast',
  'Grootschermer',
  'Grou',
  'Grubbenvorst',
  'Gulpen',
  'Guttecoven',
  'Gytsjerk',
  'Haaften',
  'Haaksbergen',
  'Haalderen',
  'Haaren',
  'Haarle',
  'Haarlem',
  'Haarlemmerliede',
  'Haarlo',
  'Haarsteeg',
  'Haarzuilens',
  'Haastrecht',
  'Haelen',
  'Hagestein',
  'Haghorst',
  'Haler',
  'Halfweg',
  'Hall',
  'Halle',
  'Hallum',
  'Halsteren',
  'Handel',
  'Hank',
  'Hansweert',
  'Hantum',
  'Hantumeruitburen',
  'Hantumhuizen',
  'Hapert',
  'Haps',
  'Harbrinkhoek',
  'Hardenberg',
  'Harderwijk',
  'Hardinxveld-Giessendam',
  'Haren',
  'Harfsen',
  'Harich',
  'Haringhuizen',
  'Harkema',
  'Harkstede',
  'Harlingen',
  'Harmelen',
  'Harreveld',
  'Harskamp',
  'Hartwerd',
  'Haskerdijken',
  'Haskerhorne',
  'Hasselt',
  'Hattem',
  'Hattemerbroek',
  'Haule',
  'Haulerwijk',
  'Hauwert',
  'Havelte',
  'Havelterberg',
  'Hazerswoude Dorp',
  'Hazerswoude Rijndijk',
  'Hedel',
  'Hee',
  'Heeg',
  'Heel',
  'Heelsum',
  'Heelweg',
  'Heemserveen',
  'Heemskerk',
  'Heemstede',
  'Heenvliet',
  'Heerde',
  'Heerenveen',
  'Heerewaarden',
  'Heerhugowaard',
  'Heerjansdam',
  'Heerle',
  'Heerlen',
  'Heesch',
  'Heesselt',
  'Heeswijk-Dinther',
  'Heeten',
  'Heeze',
  'Hegebeintum',
  'Hegelsom',
  'Hei- en Boeicop',
  'Heibloem',
  'Heide',
  'Heijen',
  'Heijenrath',
  'Heijningen',
  'Heikant',
  'Heilig Landstichting',
  'Heiligerlee',
  'Heiloo',
  'Heinenoord',
  'Heinkenszand',
  'Heino',
  'Hekelingen',
  'Hekendorp',
  'Helden',
  'Helenaveen',
  'Hellendoorn',
  'Hellevoetsluis',
  'Hellouw',
  'Hellum',
  'Helmond',
  'Helvoirt',
  'Hem',
  'Hemelum',
  'Hemmen',
  'Hempens',
  'Hemrik',
  'Hendrik-Ido-Ambacht',
  'Hengelo',
  'Hengevelde',
  'Hengstdijk',
  'Hensbroek',
  'Herbaijum',
  'Herkenbosch',
  'Herkingen',
  'Hernen',
  'Herpen',
  'Herten',
  'Hertme',
  'Herveld',
  'Herwen',
  'Herwijnen',
  'Heteren',
  'Heukelom',
  'Heukelum',
  'Heumen',
  'Heurne',
  'Heusden',
  'Heythuysen',
  'Hezingen',
  'Hiaure',
  'Hichtum',
  'Hidaard',
  'Hierden',
  'Hieslum',
  'Hijken',
  'Hijum',
  'Hilaard',
  'Hillegom',
  'Hilvarenbeek',
  'Hilversum',
  'Hindeloopen',
  'Hinnaard',
  'Hippolytushoef',
  'Hitzum',
  'Hobrede',
  'Hoedekenskerke',
  'Hoek',
  'Hoek van Holland',
  'Hoenderloo',
  'Hoensbroek',
  'Hoenzadriel',
  'Hoevelaken',
  'Hoeven',
  'Hoge Hexel',
  'Hollandsche Rading',
  'Hollandscheveld',
  'Hollum',
  'Holsloot',
  'Holten',
  'Holthees',
  'Holtheme',
  'Holthone',
  'Holtum',
  'Holwerd',
  'Holwierde',
  'Hommerts',
  'Homoet',
  'Honselersdijk',
  'Hoofddorp',
  'Hoofdplaat',
  'Hoog Soeren',
  'Hoog-Keppel',
  'Hoogblokland',
  'Hooge Mierde',
  'Hooge Zwaluwe',
  'Hoogeloon',
  'Hoogenweg',
  'Hoogerheide',
  'Hoogersmilde',
  'Hoogeveen',
  'Hoogezand',
  'Hooghalen',
  'Hoogkarspel',
  'Hoogland',
  'Hooglanderveen',
  'Hoogmade',
  'Hoogvliet',
  'Hoogwoud',
  'Hoorn',
  'Hoornaar',
  'Hoornsterzwaag',
  'Horn',
  'Hornhuizen',
  'Horssen',
  'Horst',
  'Houten',
  'Houtigehage',
  'Houwerzijl',
  'Huijbergen',
  'Huis ter Heide',
  'Huisduinen',
  'Huissen',
  'Huizen',
  'Huizinge',
  'Hulsberg',
  'Hulsel',
  'Hulshorst',
  'Hulst',
  'Hulten',
  'Hummelo',
  'Húns',
  'Hunsel',
  'Hurdegaryp',
  'Hurwenen',
  'Idaerd',
  'Idsegahuizum',
  'Idskenhuizen',
  'Idzega',
  'Iens',
  'IJhorst',
  'IJlst',
  'IJmuiden',
  'IJpecolsga',
  'IJsbrechtum',
  'IJsselham',
  'IJsselmuiden',
  'IJsselstein',
  'IJzendijke',
  'IJzendoorn',
  'Ilpendam',
  'Indijk',
  'Ingber',
  'Ingelum',
  'Ingen',
  'It Heidenskip',
  'Itens',
  'Ittervoort',
  'Jaarsveld',
  'Jabeek',
  'Jannum',
  'Jellum',
  'Jelsum',
  'Jirnsum',
  'Jislum',
  'Jisp',
  'Jistrum',
  'Jonkerslân',
  'Jonkersvaart',
  'Joppe',
  'Jorwert',
  'Joure',
  'Jouswier',
  'Jubbega',
  'Jutrijp',
  'Kaag',
  'Kaart',
  'Kaatsheuvel',
  'Kalenberg',
  'Kallenkote',
  'Kamerik',
  'Kampen',
  'Kamperland',
  'Kamperveen',
  'Kantens',
  'Kapel-Avezaath',
  'Kapelle',
  'Kapellebrug',
  'Katlijk',
  'Kats',
  'Kattendijke',
  'Katwijk',
  'Katwoude',
  'Kedichem',
  'Keijenborg',
  'Kekerdom',
  'Kelpen-Oler',
  'Kerk-Avezaath',
  'Kerkdriel',
  'Kerkenveld',
  'Kerkrade',
  'Kerkwerve',
  'Kerkwijk',
  'Kessel',
  'Kesteren',
  'Kiel-Windeweer',
  'Kilder',
  'Kimswerd',
  'Kinderdijk',
  'Kinnum',
  'Klaaswaal',
  'Klarenbeek',
  'Klazienaveen',
  'Klazienaveen-Noord',
  'Klijndijk',
  'Klimmen',
  'Kloetinge',
  'Klooster-Lidlum',
  'Kloosterburen',
  'Kloosterhaar',
  'Kloosterzande',
  'Klundert',
  'Knegsel',
  'Koarnjum',
  'Kockengen',
  'Koedijk',
  'Koekange',
  'Koewacht',
  'Kolderwolde',
  'Kolham',
  'Kolhorn',
  'Kollum',
  'Kollumerpomp',
  'Kollumerzwaag',
  'Kommerzijl',
  'Koningsbosch',
  'Koningslust',
  'Koog aan de Zaan',
  'Kootstertille',
  'Kootwijk',
  'Kootwijkerbroek',
  'Kornhorn',
  'Kornwerderzand',
  'Kortehemmen',
  'Kortenhoef',
  'Kortgene',
  'Koudekerk aan den Rijn',
  'Koudekerke',
  'Koudum',
  'Koufurderrige',
  'Krabbendijke',
  'Kraggenburg',
  'Kreileroord',
  'Krewerd',
  'Krimpen aan de Lek',
  'Krimpen aan den IJssel',
  'Kring van Dorth',
  'Krommenie',
  'Kronenberg',
  'Kropswolde',
  'Kruiningen',
  'Kruisland',
  'Kûbaard',
  'Kudelstaart',
  'Kuinre',
  'Kuitaart',
  'Kwadendamme',
  'Kwadijk',
  'Kwintsheul',
  'Laag Zuthem',
  'Laag-Keppel',
  'Laag-Soeren',
  'Lage Mierde',
  'Lage Vuursche',
  'Lage Zwaluwe',
  'Lageland',
  'Lambertschaag',
  'Lamswaarde',
  'Landerum',
  'Landgraaf',
  'Landhorst',
  'Landsmeer',
  'Langbroek',
  'Langedijke',
  'Langelille',
  'Langelo',
  'Langenboom',
  'Langerak',
  'Langeveen',
  'Langeweg',
  'Langezwaag',
  'Langweer',
  'Laren',
  'Lathum',
  'Lattrop-Breklenkamp',
  'Lauwersoog',
  'Lauwerzijl',
  'Ledeacker',
  'Leek',
  'Leende',
  'Leens',
  'Leerbroek',
  'Leerdam',
  'Leermens',
  'Leersum',
  'Leeuwarden',
  'Legemeer',
  'Leiden',
  'Leiderdorp',
  'Leidschendam',
  'Leimuiden',
  'Leimuiderbrug',
  'Lekkerkerk',
  'Lekkum',
  'Lellens',
  'Lelystad',
  'Lemele',
  'Lemelerveld',
  'Lemiers',
  'Lemmer',
  'Lengel',
  'Lent',
  'Leons',
  'Lepelstraat',
  'Lettelbert',
  'Lettele',
  'Leunen',
  'Leur',
  'Leusden',
  'Leuth',
  'Leutingewolde',
  'Leuvenheim',
  'Leveroy',
  'Lewedorp',
  'Lexmond',
  'Lichtaard',
  'Lichtenvoorde',
  'Liempde',
  'Lienden',
  'Lierderholthuis',
  'Lieren',
  'Lierop',
  'Lies',
  'Lieshout',
  'Liessel',
  'Lievelde',
  'Lieveren',
  'Lijnden',
  'Limbricht',
  'Limmen',
  'Linde',
  'Linden',
  'Linne',
  'Linschoten',
  'Lioessens',
  'Lippenhuizen',
  'Lisse',
  'Lisserbroek',
  'Lith',
  'Lithoijen',
  'Lobith',
  'Lochem',
  'Loenen',
  'Loenen aan de Vecht',
  'Loenersloot',
  'Loënga',
  'Loerbeek',
  'Lollum',
  'Lomm',
  'Longerhouw',
  'Loo',
  'Loon',
  'Loon op Zand',
  'Loosbroek',
  'Loosdrecht',
  'Loozen',
  'Lopik',
  'Lopikerkapel',
  'Loppersum',
  'Losdorp',
  'Losser',
  'Lottum',
  'Lucaswolde',
  'Luchthaven Schiphol',
  'Luddeweer',
  'Luinjeberd',
  'Lunteren',
  'Lutjebroek',
  'Lutjegast',
  'Lutjewinkel',
  'Lutkewierum',
  'Luttelgeest',
  'Lutten',
  'Luttenberg',
  'Luxwoude',
  'Luyksgestel',
  'Maarheeze',
  'Maarn',
  'Maarsbergen',
  'Maarssen',
  'Maartensdijk',
  'Maasbommel',
  'Maasbracht',
  'Maasbree',
  'Maasdam',
  'Maasdijk',
  'Maashees',
  'Maasland',
  'Maassluis',
  'Maastricht',
  'Maastricht-Airport',
  'Maasvlakte',
  'Macharen',
  'Made',
  'Makkinga',
  'Makkum',
  'Malden',
  'Mander',
  'Manderveen',
  'Mantgum',
  'Mantinge',
  'Maren-Kessel',
  'Margraten',
  'Maria Hoop',
  'Mariahout',
  'Mariaparochie',
  'Mariënberg',
  'Mariënheem',
  'Mariënvelde',
  'Marijenkampen',
  'Markelo',
  'Marken',
  'Markenbinnen',
  'Marknesse',
  'Marle',
  'Marrum',
  'Marsum',
  'Marum',
  'Marwijksoord',
  'Mastenbroek',
  'Matsloot',
  'Maurik',
  'Mechelen',
  'Medemblik',
  'Meeden',
  'Meedhuizen',
  'Meerkerk',
  'Meerlo',
  'Meerssen',
  'Meeuwen',
  'Megchelen',
  'Megen',
  'Meijel',
  'Melderslo',
  'Melick',
  'Meliskerke',
  'Melissant',
  'Menaam',
  'Mensingeweer',
  'Meppel',
  'Meppen',
  'Merkelbeek',
  'Merselo',
  'Meteren',
  'Meterik',
  'Metslawier',
  'Mheer',
  'Middelaar',
  'Middelburg',
  'Middelharnis',
  'Middelie',
  'Middelstum',
  'Middenbeemster',
  'Middenmeer',
  'Midlaren',
  'Midlum',
  'Midsland',
  'Midwolda',
  'Midwolde',
  'Midwoud',
  'Miedum',
  'Mierlo',
  'Mijdrecht',
  'Mijnsheerenland',
  'Mildam',
  'Milheeze',
  'Mill',
  'Millingen aan de Rijn',
  'Milsbeek',
  'Minnertsga',
  'Mirns',
  'Moddergat',
  'Moerdijk',
  'Moergestel',
  'Moerkapelle',
  'Moerstraten',
  'Molenaarsgraaf',
  'Molenhoek',
  'Molenschot',
  'Molkwerum',
  'Monnickendam',
  'Monster',
  'Montfoort',
  'Montfort',
  'Mook',
  'Mookhoek',
  'Moordrecht',
  'Moorveld',
  'Morra',
  'Mortel',
  'Muiden',
  'Muiderberg',
  'Mûnein',
  'Munnekeburen',
  'Munnekezijl',
  'Munstergeleen',
  'Muntendam',
  'Mussel',
  'Musselkanaal',
  'Naaldwijk',
  'Naarden',
  'Nagele',
  'Nederasselt',
  'Nederhemert',
  'Nederhorst den Berg',
  'Nederland',
  'Nederweert',
  'Nederweert-Eind',
  'Neede',
  'Neer',
  'Neerijnen',
  'Neeritter',
  'Neerkant',
  'Nes',
  'Netersel',
  'Netterden',
  'Niawier',
  'Nibbixwoud',
  'Niebert',
  'Niehove',
  'Niekerk',
  'Nietap',
  'Nieuw Balinge',
  'Nieuw en Sint Joosland',
  'Nieuw Heeten',
  'Nieuw Vennep',
  'Nieuw-Amsterdam',
  'Nieuw-Annerveen',
  'Nieuw-Beerta',
  'Nieuw-Beijerland',
  'Nieuw-Buinen',
  'Nieuw-Dordrecht',
  'Nieuw-Lekkerland',
  'Nieuw-Namen',
  'Nieuw-Roden',
  'Nieuw-Scheemda',
  'Nieuw-Schoonebeek',
  'Nieuw-Vossemeer',
  'Nieuw-Weerdinge',
  'Nieuwaal',
  'Nieuwdorp',
  'Nieuwe Niedorp',
  'Nieuwe Pekela',
  'Nieuwe Wetering',
  'Nieuwe-Tonge',
  'Nieuwebrug',
  'Nieuwediep',
  'Nieuwegein',
  'Nieuwehorne',
  'Nieuwendijk',
  'Nieuwer-Ter-Aa',
  'Nieuwerbrug',
  'Nieuwerkerk',
  'Nieuwerkerk aan den IJssel',
  'Nieuweroord',
  'Nieuwersluis',
  'Nieuweschoot',
  'Nieuwkoop',
  'Nieuwkuijk',
  'Nieuwland',
  'Nieuwlande',
  'Nieuwlande Coevorden',
  'Nieuwleusen',
  'Nieuwolda',
  'Nieuwpoort',
  'Nieuwstadt',
  'Nieuwveen',
  'Nieuwvliet',
  'Niezijl',
  'Niftrik',
  'Nigtevecht',
  'Nij Beets',
  'Nijbroek',
  'Nijeberkoop',
  'Nijega',
  'Nijehaske',
  'Nijeholtpade',
  'Nijeholtwolde',
  'Nijelamer',
  'Nijemirdum',
  'Nijensleek',
  'Nijetrijne',
  'Nijeveen',
  'Nijhuizum',
  'Nijkerk',
  'Nijkerkerveen',
  'Nijland',
  'Nijlande',
  'Nijmegen',
  'Nijverdal',
  'Nispen',
  'Nisse',
  'Nistelrode',
  'Noardburgum',
  'Nooitgedacht',
  'Noorbeek',
  'Noord-Scharwoude',
  'Noord-Sleen',
  'Noordbeemster',
  'Noordbroek',
  'Noordeinde',
  'Noordeloos',
  'Noorden',
  'Noordgouwe',
  'Noordhoek',
  'Noordhorn',
  'Noordlaren',
  'Noordscheschut',
  'Noordwelle',
  'Noordwijk',
  'Noordwijkerhout',
  'Noordwolde',
  'Nootdorp',
  'Norg',
  'Notter',
  'Nuenen',
  'Nuis',
  'Nuland',
  'Numansdorp',
  'Nunhem',
  'Nunspeet',
  'Nuth',
  'Nutter',
  'Obbicht',
  'Obdam',
  'Ochten',
  'Odijk',
  'Odiliapeel',
  'Odoorn',
  'Odoornerveen',
  'Oeffelt',
  'Oegstgeest',
  'Oene',
  'Oentsjerk',
  'Offingawier',
  'Ohé en Laak',
  'Oijen',
  'Oirlo',
  'Oirsbeek',
  'Oirschot',
  'Oisterwijk',
  'Okkenbroek',
  'Olburgen',
  'Oldeberkoop',
  'Oldebroek',
  'Oldeholtpade',
  'Oldeholtwolde',
  'Oldehove',
  'Oldekerk',
  'Oldelamer',
  'Oldemarkt',
  'Oldenzaal',
  'Oldenzijl',
  'Oldeouwer',
  'Oldetrijne',
  'Olst',
  'Olterterp',
  'Ommel',
  'Ommen',
  'Ommeren',
  'Onderdendam',
  'Onna',
  'Onnen',
  'Onstwedde',
  'Ooij',
  'Ooltgensplaat',
  'Oost- West- en Middelbeers',
  'Oost-Graftdijk',
  'Oost-Souburg',
  'Oostburg',
  'Oostdijk',
  'Oosteind',
  'Oosterbeek',
  'Oosterbierum',
  'Oosterblokker',
  'Oosterend',
  'Oosterhesselen',
  'Oosterhout',
  'Oosterland',
  'Oosterleek',
  'Oosternieland',
  'Oosternijkerk',
  'Oosterstreek',
  'Oosterwijk',
  'Oosterwijtwerd',
  'Oosterwolde',
  'Oosterzee',
  'Oosthem',
  'Oosthuizen',
  'Oostkapelle',
  'Oostknollendam',
  'Oostrum',
  'Oostvoorne',
  'Oostwold',
  'Oostwoud',
  'Oostzaan',
  'Ootmarsum',
  'Opeinde',
  'Opende',
  'Ophemert',
  'Opheusden',
  'Opijnen',
  'Oploo',
  'Opmeer',
  'Oppenhuizen',
  'Opperdoes',
  'Oranje',
  'Oranjewoud',
  'Orvelte',
  'Ospel',
  'Oss',
  'Ossendrecht',
  'Ossenisse',
  'Ossenwaard',
  'Ossenzijl',
  'Oterleek',
  'Otterlo',
  'Ottersum',
  'Ottoland',
  'Oud Gastel',
  'Oud-Ade',
  'Oud-Alblas',
  'Oud-Annerveen',
  'Oud-Beijerland',
  'Oud-Ootmarsum',
  'Oud-Vossemeer',
  'Oud-Zuilen',
  'Ouddorp',
  'Oude Bildtzijl',
  'Oude Meer',
  'Oude Pekela',
  'Oude Wetering',
  'Oude Willem',
  'Oude-Niedorp',
  'Oude-Tonge',
  'Oudega',
  'Oudehaske',
  'Oudehorne',
  'Oudelande',
  'Oudemirdum',
  'Oudemolen',
  'Oudenbosch',
  'Oudendijk',
  'Oudenhoorn',
  'Ouderkerk aan de Amstel',
  'Ouderkerk aan den IJssel',
  'Oudeschans',
  'Oudeschild',
  'Oudeschip',
  'Oudeschoot',
  'Oudesluis',
  'Oudewater',
  'Oudezijl',
  'Oudkarspel',
  'Oudorp',
  'Oudwoude',
  'Ouwerkerk',
  'Ouwster-Nijega',
  'Ouwsterhaule',
  'Overasselt',
  'Overberg',
  'Overdinkel',
  'Overloon',
  'Overschild',
  'Overslag',
  'Overveen',
  'Ovezande',
  'Paasloo',
  'Paesens',
  'Pannerden',
  'Panningen',
  'Papekop',
  'Papendrecht',
  'Papenhoven',
  'Papenvoort',
  'Parrega',
  'Paterswolde',
  'Peest',
  'Peins',
  'Peize',
  'Peperga',
  'Pernis',
  'Persingen',
  'Pesse',
  'Petten',
  'Philippine',
  'Piaam',
  'Piershil',
  'Pieterburen',
  'Pietersbierum',
  'Pieterzijl',
  'Pijnacker',
  'Pingjum',
  'Plasmolen',
  'Poederoijen',
  'Poeldijk',
  'Polsbroek',
  'Poortugaal',
  'Poortvliet',
  'Poppenwier',
  'Posterholt',
  'Prinsenbeek',
  'Puiflijk',
  'Punthorst',
  'Purmer',
  'Purmerend',
  'Purmerland',
  'Puth',
  'Putte',
  'Putten',
  'Puttershoek',
  'Raalte',
  'Raamsdonk',
  'Raamsdonksveer',
  'Raard',
  'Radewijk',
  'Radio Kootwijk',
  'Raerd',
  'Randwijk',
  'Ransdaal',
  'Rasquert',
  'Ravenstein',
  'Ravenswaaij',
  'Ravenswoud',
  'Readtsjerk',
  'Reahûs',
  'Reduzum',
  'Reek',
  'Reeuwijk',
  'Reijmerstok',
  'Reitsum',
  'Rekken',
  'Renesse',
  'Renkum',
  'Renswoude',
  'Ressen',
  'Retranchement',
  'Reusel',
  'Reutum',
  'Reuver',
  'Rha',
  'Rheden',
  'Rhee',
  'Rheeze',
  'Rheezerveen',
  'Rhenen',
  'Rhenoy',
  'Rhoon',
  'Ridderkerk',
  'Ried',
  'Riel',
  'Rien',
  'Riethoven',
  'Rietmolen',
  'Rijen',
  'Rijkevoort',
  'Rijkevoort-De Walsert',
  'Rijnsaterwoude',
  'Rijnsburg',
  'Rijpwetering',
  'Rijs',
  'Rijsbergen',
  'Rijsenhout',
  'Rijssen',
  'Rijswijk',
  'Rilland',
  'Rinsumageast',
  'Rips',
  'Ritthem',
  'Rockanje',
  'Roden',
  'Roderesch',
  'Roderwolde',
  'Roelofarendsveen',
  'Roermond',
  'Rogat',
  'Roggel',
  'Rohel',
  'Rolde',
  'Roodeschool',
  'Roosendaal',
  'Roosteren',
  'Rosmalen',
  'Rossum',
  'Roswinkel',
  'Rotstergaast',
  'Rotsterhaule',
  'Rotterdam',
  'Rottevalle',
  'Rottum',
  'Rouveen',
  'Rozenburg',
  'Rozendaal',
  'Rucphen',
  'Ruigahuizen',
  'Ruinen',
  'Ruinerwold',
  'Rumpt',
  'Rutten',
  'Ruurlo',
  'Ryptsjerk',
  '\'s-Graveland',
  '\'s-Gravendeel',
  '\'s-Gravenmoer',
  '\'s-Gravenpolder',
  '\'s-Gravenzande',
  '\'s-Heer-Abtskerke',
  '\'s-Heer-Arendskerke',
  '\'s-Heer-Hendrikskinderen',
  '\'s-Heerenberg',
  '\'s-Heerenbroek',
  '\'s-Heerenhoek',
  '\'s-Hertogenbosch',
  'Saaksum',
  'Saasveld',
  'Saaxumhuizen',
  'Sambeek',
  'Sandfirden',
  'Santpoort-Noord',
  'Santpoort-Zuid',
  'Sappemeer',
  'Sas van Gent',
  'Sassenheim',
  'Sauwerd',
  'Schagen',
  'Schagerbrug',
  'Schaijk',
  'Schalkhaar',
  'Schalkwijk',
  'Schalsum',
  'Schardam',
  'Scharendijke',
  'Scharmer',
  'Scharnegoutum',
  'Scharsterbrug',
  'Scharwoude',
  'Scheemda',
  'Scheerwolde',
  'Schellinkhout',
  'Schelluinen',
  'Schermerhorn',
  'Scherpenisse',
  'Scherpenzeel',
  'Schettens',
  'Scheulder',
  'Schiedam',
  'Schiermonnikoog',
  'Schijf',
  'Schijndel',
  'Schildwolde',
  'Schimmert',
  'Schin op Geul',
  'Schinnen',
  'Schinveld',
  'Schipborg',
  'Schiphol',
  'Schiphol-Rijk',
  'Schipluiden',
  'Schokland',
  'Schoondijke',
  'Schoonebeek',
  'Schoonhoven',
  'Schoonloo',
  'Schoonoord',
  'Schoonrewoerd',
  'Schoorl',
  'Schore',
  'Schouwerzijl',
  'Schraard',
  'Schuinesloot',
  'Sebaldeburen',
  'Seerijp',
  'Sellingen',
  'Serooskerke',
  'Sevenum',
  'Sexbierum',
  'Sibculo',
  'Sibrandabuorren',
  'Sibrandahûs',
  'Siddeburen',
  'Siebengewald',
  'Siegerswoude',
  'Sijbekarspel',
  'Silvolde',
  'Simonshaven',
  'Simpelveld',
  'Sinderen',
  'Sint Agatha',
  'Sint Annaland',
  'Sint Annaparochie',
  'Sint Annen',
  'Sint Anthonis',
  'Sint Geertruid',
  'Sint Hubert',
  'Sint Jacobiparochie',
  'Sint Jansklooster',
  'Sint Jansteen',
  'Sint Joost',
  'Sint Kruis',
  'Sint Maarten',
  'Sint Maartensbrug',
  'Sint Maartensdijk',
  'Sint Maartensvlotbrug',
  'Sint Nicolaasga',
  'Sint Odiliënberg',
  'Sint Pancras',
  'Sint Philipsland',
  'Sint Willebrord',
  'Sint-Michielsgestel',
  'Sint-Oedenrode',
  'Sintjohannesga',
  'Sirjansland',
  'Sittard',
  'Skingen',
  'Slagharen',
  'Slappeterp',
  'Sleen',
  'Sleeuwijk',
  'Slenaken',
  'Sliedrecht',
  'Slijk-Ewijk',
  'Slijkenburg',
  'Slochteren',
  'Slootdorp',
  'Sloten',
  'Sluis',
  'Sluiskil',
  'Smakt',
  'Smalle Ee',
  'Smallebrugge',
  'Smilde',
  'Snakkerburen',
  'Sneek',
  'Snelrewaard',
  'Snikzwaag',
  'Soerendonk',
  'Soest',
  'Soesterberg',
  'Someren',
  'Sommelsdijk',
  'Son',
  'Sondel',
  'Sonnega',
  'Spaarndam',
  'Spaarndam-West',
  'Spanbroek',
  'Spanga',
  'Spankeren',
  'Spannum',
  'Spaubeek',
  'Spier',
  'Spierdijk',
  'Spijk',
  'Spijkenisse',
  'Spijkerboor',
  'Sprang-Capelle',
  'Sprundel',
  'Spui',
  'Stad aan \'t Haringvliet',
  'Stadskanaal',
  'Stampersgat',
  'Standdaarbuiten',
  'Staphorst',
  'Starnmeer',
  'Startenhuizen',
  'Stavenisse',
  'Stavoren',
  'Stedum',
  'Steenbergen',
  'Steendam',
  'Steenderen',
  'Steenenkamer',
  'Steensel',
  'Steenwijk',
  'Steenwijkerwold',
  'Stegeren',
  'Steggerda',
  'Steijl',
  'Stein',
  'Stellendam',
  'Sterksel',
  'Stevensbeek',
  'Stevensweert',
  'Stieltjeskanaal',
  'Stiens',
  'Stitswerd',
  'Stokkum',
  'Stolwijk',
  'Stompetoren',
  'Stoutenburg',
  'Stoutenburg Noord',
  'Stramproy',
  'Streefkerk',
  'Strijbeek',
  'Strijen',
  'Strijensas',
  'Stroe',
  'Stroobos',
  'Stuifzand',
  'Sumar',
  'Surhuisterveen',
  'Surhuizum',
  'Susteren',
  'Suwâld',
  'Swalmen',
  'Sweikhuizen',
  'Swichum',
  'Swifterbant',
  'Swolgen',
  '\'t Goy',
  '\'t Haantje',
  '\'t Harde',
  '\'t Loo Oldebroek',
  '\'t Veld',
  '\'t Waar',
  '\'t Zand',
  '\'t Zandt',
  'Taarlo',
  'Teeffelen',
  'Teerns',
  'Tegelen',
  'Ten Post',
  'Ter Aar',
  'Ter Aard',
  'Ter Apel',
  'Ter Apelkanaal',
  'Ter Heijde',
  'Ter Hole',
  'Ter Idzard',
  'Terband',
  'Terborg',
  'Terheijden',
  'Terherne',
  'Terkaple',
  'Termunten',
  'Termunterzijl',
  'Ternaard',
  'Terneuzen',
  'Teroele',
  'Terschuur',
  'Tersoal',
  'Terwispel',
  'Terwolde',
  'Teteringen',
  'Teuge',
  'Thesinge',
  'Tholen',
  'Thorn',
  'Tiel',
  'Tiendeveen',
  'Tienhoven',
  'Tienray',
  'Tijnje',
  'Tilburg',
  'Tilligte',
  'Tinallinge',
  'Tinte',
  'Tirns',
  'Tjalhuizum',
  'Tjalleberd',
  'Tjerkgaast',
  'Tjerkwerd',
  'Tjuchem',
  'Tolbert',
  'Toldijk',
  'Tolkamer',
  'Tollebeek',
  'Tonden',
  'Toornwerd',
  'Tricht',
  'Triemen',
  'Tripscompagnie',
  'Tubbergen',
  'Tuil',
  'Tuitjenhorn',
  'Tuk',
  'Tull en \'t Waal',
  'Tweede Exloërmond',
  'Tweede Valthermond',
  'Twello',
  'Twijzel',
  'Twijzelerheide',
  'Twisk',
  'Tynaarlo',
  'Tytsjerk',
  'Tzum',
  'Tzummarum',
  'Ubbena',
  'Ubbergen',
  'Uddel',
  'Uden',
  'Udenhout',
  'Uffelte',
  'Ugchelen',
  'Uitdam',
  'Uitgeest',
  'Uithoorn',
  'Uithuizen',
  'Uithuizermeeden',
  'Uitwellingerga',
  'Uitwijk',
  'Ulestraten',
  'Ulft',
  'Ulicoten',
  'Ulrum',
  'Ulvenhout',
  'Ureterp',
  'Urk',
  'Urmond',
  'Ursem',
  'Usquert',
  'Utrecht',
  'Vaals',
  'Vaassen',
  'Valburg',
  'Valkenburg',
  'Valkenswaard',
  'Valthe',
  'Valthermond',
  'Varik',
  'Varsselder-Veldhunten',
  'Varsseveld',
  'Vasse',
  'Veelerveen',
  'Veen',
  'Veendam',
  'Veenendaal',
  'Veenhuizen',
  'Veeningen',
  'Veenklooster',
  'Veenoord',
  'Veere',
  'Veessen',
  'Vegelinsoord',
  'Veghel',
  'Velddriel',
  'Velden',
  'Veldhoven',
  'Velp',
  'Velsen-Noord',
  'Velsen-Zuid',
  'Velserbroek',
  'Ven-Zelderheide',
  'Venebrugge',
  'Venhorst',
  'Venhuizen',
  'Venlo',
  'Venray',
  'Vessem',
  'Vethuizen',
  'Veulen',
  'Vianen',
  'Vierakker',
  'Vierhouten',
  'Vierhuizen',
  'Vierlingsbeek',
  'Vierpolders',
  'Vijfhuizen',
  'Vijlen',
  'Vilsteren',
  'Vinkega',
  'Vinkel',
  'Vinkenbuurt',
  'Vinkeveen',
  'Visvliet',
  'Vlaardingen',
  'Vlagtwedde',
  'Vledder',
  'Vledderveen',
  'Vleuten',
  'Vlieland',
  'Vlierden',
  'Vlijmen',
  'Vlissingen',
  'Vlist',
  'Vlodrop',
  'Voerendaal',
  'Vogelenzang',
  'Vogelwaarde',
  'Volendam',
  'Volkel',
  'Vollenhove',
  'Vondelingenplaat',
  'Voorburg',
  'Voorhout',
  'Voorschoten',
  'Voorst',
  'Voorthuizen',
  'Vorchten',
  'Vorden',
  'Vorstenbosch',
  'Vortum-Mullem',
  'Vragender',
  'Vredenheim',
  'Vredepeel',
  'Vreeland',
  'Vries',
  'Vriescheloo',
  'Vriezenveen',
  'Vroomshoop',
  'Vrouwenakker',
  'Vrouwenparochie',
  'Vrouwenpolder',
  'Vught',
  'Vuren',
  'Waaksens',
  'Waal',
  'Waalre',
  'Waalwijk',
  'Waarde',
  'Waardenburg',
  'Waarder',
  'Waardhuizen',
  'Waarland',
  'Waaxens',
  'Wachtum',
  'Waddinxveen',
  'Wadenoijen',
  'Wagenberg',
  'Wagenborgen',
  'Wageningen',
  'Walem',
  'Walsoorden',
  'Wâlterswâld',
  'Wamel',
  'Wanneperveen',
  'Wanroij',
  'Wanssum',
  'Wânswert',
  'Wapenveld',
  'Wapse',
  'Wapserveen',
  'Warder',
  'Warffum',
  'Warfhuizen',
  'Warfstermolen',
  'Warmenhuizen',
  'Warmond',
  'Warns',
  'Warnsveld',
  'Warstiens',
  'Warten',
  'Waskemeer',
  'Waspik',
  'Wassenaar',
  'Wateren',
  'Watergang',
  'Waterhuizen',
  'Wateringen',
  'Waterlandkerkje',
  'Waverveen',
  'Wedde',
  'Weerselo',
  'Weert',
  'Weesp',
  'Wehe-Den Hoorn',
  'Wehl',
  'Weidum',
  'Weiteveen',
  'Wekerom',
  'Well',
  'Wellerlooi',
  'Welsum',
  'Wemeldinge',
  'Wenum Wiesel',
  'Wergea',
  'Werkendam',
  'Werkhoven',
  'Wernhout',
  'Wervershoof',
  'Wesepe',
  'Wessem',
  'West-Graftdijk',
  'West-Terschelling',
  'Westbeemster',
  'Westbroek',
  'Westdorp',
  'Westdorpe',
  'Westendorp',
  'Westerbeek',
  'Westerbork',
  'Westerbroek',
  'Westeremden',
  'Westergeest',
  'Westerhaar-Vriezenveensewijk',
  'Westerhoven',
  'Westerland',
  'Westerlee',
  'Westernieland',
  'Westervelde',
  'Westervoort',
  'Westerwijtwerd',
  'Westhem',
  'Westhoek',
  'Westkapelle',
  'Westknollendam',
  'Westmaas',
  'Westwoud',
  'Westzaan',
  'Wetering',
  'Weteringbrug',
  'Wetsens',
  'Wetsinge',
  'Weurt',
  'Wezep',
  'Wezup',
  'Wezuperbrug',
  'Wichmond',
  'Wier',
  'Wierden',
  'Wieringerwaard',
  'Wieringerwerf',
  'Wierum',
  'Wieuwerd',
  'Wijchen',
  'Wijckel',
  'Wijdenes',
  'Wijdewormer',
  'Wijhe',
  'Wijk aan Zee',
  'Wijk bij Duurstede',
  'Wijk en Aalburg',
  'Wijlre',
  'Wijnaldum',
  'Wijnandsrade',
  'Wijnbergen',
  'Wijngaarden',
  'Wijnjewoude',
  'Wijster',
  'Wilbertoord',
  'Wildervank',
  'Wilhelminadorp',
  'Wilhelminaoord',
  'Willemsoord',
  'Willemstad',
  'Wilnis',
  'Wilp',
  'Wilsum',
  'Winde',
  'Windraak',
  'Winkel',
  'Winneweer',
  'Winschoten',
  'Winssen',
  'Winsum',
  'Wintelre',
  'Winterswijk',
  'Winterswijk Brinkheurne',
  'Winterswijk Corle',
  'Winterswijk Henxel',
  'Winterswijk Huppel',
  'Winterswijk Kotten',
  'Winterswijk Meddo',
  'Winterswijk Miste',
  'Winterswijk Ratum',
  'Winterswijk Woold',
  'Wirdum',
  'Wissenkerke',
  'Witharen',
  'Witmarsum',
  'Witte Paarden',
  'Wittelte',
  'Wittem',
  'Witteveen',
  'Wjelsryp',
  'Woensdrecht',
  'Woerden',
  'Woerdense Verlaat',
  'Wognum',
  'Woldendorp',
  'Wolfheze',
  'Wolphaartsdijk',
  'Wolsum',
  'Woltersum',
  'Wolvega',
  'Wommels',
  'Wons',
  'Workum',
  'Wormer',
  'Wormerveer',
  'Woubrugge',
  'Woudbloem',
  'Woudenberg',
  'Woudrichem',
  'Woudsend',
  'Wouw',
  'Wouwse Plantage',
  'Wyns',
  'Wytgaard',
  'Yde',
  'Yerseke',
  'Ysselsteyn',
  'Zaamslag',
  'Zaandam',
  'Zaandijk',
  'Zalk',
  'Zaltbommel',
  'Zandberg',
  'Zandeweer',
  'Zandhuizen',
  'Zandpol',
  'Zandvoort',
  'Zeddam',
  'Zeegse',
  'Zeeland',
  'Zeerijp',
  'Zeewolde',
  'Zegge',
  'Zegveld',
  'Zeijen',
  'Zeijerveen',
  'Zeijerveld',
  'Zeist',
  'Zelhem',
  'Zenderen',
  'Zennewijnen',
  'Zetten',
  'Zevenaar',
  'Zevenbergen',
  'Zevenbergschen Hoek',
  'Zevenhoven',
  'Zevenhuizen',
  'Zierikzee',
  'Zieuwent',
  'Zijderveld',
  'Zijdewind',
  'Zijldijk',
  'Zoelen',
  'Zoelmond',
  'Zoetermeer',
  'Zoeterwoude',
  'Zonnemaire',
  'Zorgvlied',
  'Zoutelande',
  'Zoutkamp',
  'Zuid-Beijerland',
  'Zuid-Scharwoude',
  'Zuidbroek',
  'Zuiddorpe',
  'Zuidermeer',
  'Zuiderwoude',
  'Zuidhorn',
  'Zuidlaarderveen',
  'Zuidland',
  'Zuidlaren',
  'Zuidoostbeemster',
  'Zuidschermer',
  'Zuidveen',
  'Zuidveld',
  'Zuidvelde',
  'Zuidwolde',
  'Zuidzande',
  'Zuilichem',
  'Zuna',
  'Zundert',
  'Zurich',
  'Zutphen',
  'Zuurdijk',
  'Zwaag',
  'Zwaagdijk',
  'Zwaanshoek',
  'Zwagerbosch',
  'Zwammerdam',
  'Zwanenburg',
  'Zwartebroek',
  'Zwartemeer',
  'Zwartewaal',
  'Zwartsluis',
  'Zweeloo',
  'Zweins',
  'Zwiggelte',
  'Zwijndrecht',
  'Zwinderen',
  'Zwolle',
]
